import React, { useCallback, useEffect } from 'react'
import { Box, Grid, Typography } from '@mui/material';
import { formStyle, stepNumberStyle, formTitleStyle, formDesStyle, topUnderlineStyle, sectionContainer, smallLabel } from '../../../constant/material_style';
import CustomTextfield from '../../../component/custom_textfield';
import { paymentTerms } from '../../../constant/selection';
import { useForm } from 'react-hook-form';
import _ from 'lodash';
import moment from 'moment';
import { useStateContext } from '../../../contexts/StepFormContextProvider';
import { handleUpdateForm } from '../../../api/rc_admission_form';

const ServiceAgreementSchedule2 = ({ isAdmin, currentStep, setCurrentStep, formValues, setFormValues }) => {
	const { control, reset, handleSubmit, setValue, formState: { errors }} = useForm({ mode: 'onChange' });
	const { formId } = useStateContext();

	useEffect(() => {
		reset(formValues);
	}, [formValues.room_type, formValues.price_per_month, formValues.deposit, formValues.services_schedule_2, formValues.others, formValues.total, formValues.payment_terms]);

	const debounceSetValues = useCallback(
		_.debounce((name, value) => {
			setValue(name, value, { shouldValidate: true });

			setFormValues((prev) => {
				const newFormValues = { ...prev, [name]: value };
				const updatedValue = { [name]: value };

				if(formId) {
					handleUpdateForm(formId, updatedValue);
				}

				setFormValues(newFormValues);
				return newFormValues;
			});
		}, 500), [setValue, setFormValues, formId]
	);

	const handleChange = (name, value) => {
		debounceSetValues(name, value);
	}

	const goback = (e) => {
		setCurrentStep(currentStep - 1);
	}

	const onSubmit = (e) => {
		setCurrentStep(currentStep + 1);
	}

	return (
		<form onSubmit={handleSubmit(onSubmit)}>
			<Box style={formStyle}>
				<Grid container alignItems="flex-start" spacing={2} style={{ marginBottom: '20px', overflowY: 'auto' }}>
					<Grid item>
						<Box style={stepNumberStyle}>{currentStep}</Box>
					</Grid>
					<Grid item xs style={{ paddingLeft: '0' }}>
						<Typography style={formTitleStyle}>Service Agreement - Schedule 2</Typography>
						<Typography style={formDesStyle}>Service Fee</Typography>
					</Grid>
				</Grid>

				{/* per section */}
				<Box style={sectionContainer}>
					<Box style={topUnderlineStyle}>
						<Typography style={formDesStyle}>Schedule 2</Typography>
					</Box>
				</Box>

				<Box style={sectionContainer}>
					<Grid container spacing={2}>
						<Grid item xs={12} sm={8}>
							<CustomTextfield
								name='room_type' formValue={formValues.room_type} control={control} errors={errors}
								label="1. Room Type" typeOfField="text1" onChangeVal={handleChange} small={false} readOnly={!isAdmin} isAdmin={isAdmin}
							/>
						</Grid>
					</Grid>
				</Box>

				<Box style={sectionContainer}>
					<Grid container spacing={2}>
						<Grid item xs={12} sm={8}>
							<CustomTextfield
								name='price_per_month' formValue={formValues.price_per_month} control={control} errors={errors}
								label="2. Price Per Month" typeOfField="currency" onChangeVal={handleChange} small={false} readOnly={!isAdmin} isAdmin={isAdmin}
							/>
						</Grid>
					</Grid>
				</Box>

				<Box style={sectionContainer}>
					<Grid container spacing={2}>
						<Grid item xs={12} sm={8}>
							<CustomTextfield
								name='deposit' formValue={formValues.deposit} control={control} errors={errors}
								label="3. Deposit" typeOfField="currency" onChangeVal={handleChange} small={false} readOnly={!isAdmin} isAdmin={isAdmin}
							/>
						</Grid>
					</Grid>
				</Box>

				<Box style={sectionContainer}>
					<Grid container spacing={2}>
						<Grid item xs={12} sm={8}>
							<CustomTextfield
								name='services_schedule_2' formValue={formValues.services_schedule_2} control={control} errors={errors}
								label="4. Services" typeOfField="text1" onChangeVal={handleChange} small={false} readOnly={!isAdmin} isAdmin={isAdmin}
							/>
						</Grid>
					</Grid>
				</Box>

				<Box style={sectionContainer}>
					<Grid container spacing={2}>
						<Grid item xs={12} sm={8}>
							<CustomTextfield
								name='others' formValue={formValues.others} control={control} errors={errors}
								label="5. Others" typeOfField="text1" onChangeVal={handleChange} small={false} readOnly={!isAdmin} isAdmin={isAdmin}
							/>
						</Grid>
					</Grid>
				</Box>

				<Box style={sectionContainer}>
					<Grid container spacing={2}>
						<Grid item xs={12} sm={8}>
							<CustomTextfield
								name='total' formValue={formValues.total} control={control} errors={errors}
								label="6. Total" typeOfField="currency" onChangeVal={handleChange} small={false} readOnly={!isAdmin} isAdmin={isAdmin}
							/>
						</Grid>
					</Grid>
				</Box>

				<Box style={sectionContainer}>
					<Grid container spacing={2}>
						<Grid item xs={12} sm={8}>
							<CustomTextfield
								name='commencement_date_schedule_2' formValue={formValues.commencement_date_schedule_2 ?? moment()}
								label="7. Commencement Date" typeOfField="datePicker" onChangeVal={handleChange} small={false} control={control} errors={errors} readOnly={!isAdmin} isAdmin={isAdmin}
							/>
						</Grid>
					</Grid>
				</Box>

				<Box style={sectionContainer}>
					<Grid container spacing={2}>
						<Grid item xs={12} sm={8}>
							<CustomTextfield
								name='payment_terms' formValue={formValues.payment_terms} small={false} control={control} errors={errors}
								label="8. Payment Terms" typeOfField="select1" onChangeVal={handleChange} selectLists={paymentTerms} readOnly={!isAdmin} isAdmin={isAdmin}
							/>
						</Grid>
					</Grid>
				</Box>

				<Box style={sectionContainer}>
					<Typography style={smallLabel}>
						For the avoidance of doubt, the Service Fee shall only include the aforesaid items and all other costs and expenses including but not limited to the following shall be excluded and shall be charged separately. All such addition costs and expenses incurred shall be become a debt due from the
					</Typography>
					<Typography style={smallLabel}>Customer to the Provider:-</Typography>
					<Typography style={smallLabel}>(a) disposal diapers; and</Typography>
					<Typography style={smallLabel}>(b) medications.</Typography>
				</Box>

				<div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '30px' }}>
					<button className='t-accept-button' onClick={goback}>Previous</button>
					<button type="submit" className='t-accept-button'>Next</button>
				</div>
			</Box>
		</form>
	)
}

export default ServiceAgreementSchedule2